import React from 'react'
import Scheduler from './pages/Scheduler'
import { SchedulerAppProvider } from './context/SchedulerContext'

const SchedulerHome = () => {
  return (
   <>
   <SchedulerAppProvider>
    <Scheduler/>
   </SchedulerAppProvider>
    
   </>
  )
}

export default SchedulerHome